import React, { useEffect, useState } from "react";
import { InputPadrao, LabelPadrao, ModalPadrao } from "../../components/Base";
import { Radio, Space } from "antd";
import { BtnGravar, BtnSair } from "../../components/Buttons";

const INITIAL = { bandeira: null, cartaoEmpresaTipo: null, cartaoPagamentoDados: null };

export default function ModalCartao({ onOk, onCancel, visible, pg, edicao, cartaoEmpresaTipos, isEntrega }) {
  const [cartao, setCartao] = useState(INITIAL);

  useEffect(() => {
    if (visible && !!edicao)
      setCartao(edicao);
    else
      setCartao(INITIAL);
  }, [visible]);

  const cartaoEmpresaTiposInterno = (cartaoEmpresaTipos || []).filter(x => !isEntrega || x.isEntrega);

  const hasBandeira = cartaoEmpresaTiposInterno.find(s => s.tipo == cartao.cartaoEmpresaTipo)?.hasBandeira ?? pg.hasBandeira;

  return <ModalPadrao title={`Informe os dados do cartão: ${pg.nome}`} visible={visible} footer={<>
    <BtnGravar txt="Confirmar" onClick={() => { onOk(cartao); setCartao(INITIAL); }} disabled={cartaoEmpresaTiposInterno?.length ? ((!cartao.bandeira && hasBandeira) || !cartao.cartaoEmpresaTipo) : !cartao.bandeira} />
    <BtnSair onClick={() => { onCancel(); setCartao(INITIAL); }} />
  </>} closable={false}>

    {!!cartaoEmpresaTiposInterno?.length && <>
      <LabelPadrao noMargin>Tipo autorização</LabelPadrao>
      <Radio.Group onChange={v => setCartao({ ...cartao, cartaoEmpresaTipo: v.target.value, cartaoPagamentoDados: cartaoEmpresaTiposInterno.find(s => s.tipo == v.target.value)?.isManual ? { tipo: v.target.value } : null, bandeira: null, bandeiraNome: null })} value={cartao.cartaoEmpresaTipo}>
        <Space direction="vertical">
          {cartaoEmpresaTiposInterno.map(x => <Radio key={x.tipo} value={x.tipo}>{x.descricao}</Radio>)}
        </Space>
      </Radio.Group>
    </>}

    {hasBandeira && <>
      <LabelPadrao>Bandeira</LabelPadrao>
      <Radio.Group onChange={v => setCartao({ ...cartao, bandeira: v.target.value, bandeiraNome: bandeiras.find(x => x.id == v.target.value)?.nome })} value={cartao.bandeira}>
        <Space direction="vertical">
          {bandeiras.map(x => <Radio key={x.id} value={x.id}>{x.nome}</Radio>)}
        </Space>
      </Radio.Group>
    </>}

    {!!cartao?.cartaoPagamentoDados && <>
      <LabelPadrao>Autorização</LabelPadrao>
      <InputPadrao value={cartao.cartaoPagamentoDados?.autorizacao} onChange={v => setCartao({ ...cartao, cartaoPagamentoDados: { ...cartao.cartaoPagamentoDados, autorizacao: v.target.value } })} placeholder="Informe a autorização" />
    </>}
  </ModalPadrao>;

}

const bandeiras = [
  { id: "01", nome: "Visa" },
  { id: "02", nome: "Mastercard" },
  { id: "03", nome: "American Express" },
  { id: "04", nome: "Sorocred" },
  { id: "05", nome: "Diners Club" },
  { id: "06", nome: "Elo" },
  { id: "07", nome: "Hipercard" },
  { id: "08", nome: "Aura" },
  { id: "09", nome: "Cabal" },
  { id: "99", nome: "Outros" }
];